<template>
  <div ref="getheight" class="wrap">
    <el-container>
      <el-main>
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form :inline="true" ref="form" :model="searchForm" class="demo-form-inline">
              <div class="uers-left">
                <el-form-item label="搜索：">
                  <el-input v-model="searchForm.name" placeholder="姓名"></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input v-model="searchForm.project" placeholder="项目"></el-input>
                </el-form-item>
                <el-form-item label>
                  <el-input v-model="searchForm.role" placeholder="角色"></el-input>
                </el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="searchSubmit(searchForm)">搜索</el-button>
              </div>
              <div class="uers-right">
                <span class="btn-r">
                  <el-button type="primary" plain icon="el-icon-plus" @click="addSubmit">新增</el-button>
                </span>
              </div>
            </el-form>
          </div>
          <div class="tabbox">
          <el-table
            :data="dataList"
            height="100%"
            border
            class="tabbox"
            ref="multipleTable"
            :header-cell-style="{background:'#f2f6fc',color:'#606266'}"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column prop="name" label="姓名" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="project" label="项目" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.project}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="role" label="角色" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.role}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="createDate" label="创建时间" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.createDate}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作"  align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="handleEdit(scope.$index,scope.row)">编辑</el-button>
                <el-button type="text" class="red" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table></div>
          <div class="fb"><el-pagination
            class="pag"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          ></el-pagination></div>
        </div>
        <DeleteDialog
          :delVisible="delVisible"
          @deleteData="deleteData"
          @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditUserRole :editShow="editShow" :editData="editData" @backFunStu="getFunStu"></EditUserRole>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditUserRole from "../../components/systemSetup/EditUserRoleManage";
import DeleteDialog from "../../components/public/DeleteConfim";

export default {
  data() {
    return {
      total: 10, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      totalPage: 0,
      searchForm: {
        role: "",
        project: "",
        name: ""
      },
      editData: {},
      listShow: true,
      delVisible: false,
      indexid: "",
      editShow: false,
      dataList: [],
      multipleSelection: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    handleSizeChange(val) {
      this.pagesize = val;
      this.searchSubmit();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}`);
      this.searchSubmit();
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    searchSubmit() {
      this.search = {
        name: this.searchForm.name,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize,
        project: this.searchForm.project,
        role: this.searchForm.role
      };
      this.$axios.post("/AccountProjectRole/Search", this.search).then(res => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;;
        }
      });
    },
    addSubmit() {
      this.indexid ="";
      this.listShow = false;
      this.editShow = true;
    },
    handleDelete(index, row) {
      this.indexid = row.accountProjectRoleId;
      this.delVisible = true;
    },
    deleteData() {
      if (this.indexid) {
        this.$axios.delete(`/AccountProjectRole/${this.indexid}`).then(res => {
          if (res.data.hasError == false) {
            this.$message.success("删除成功！");
            this.getData();
          } else {
            this.$message.error("删除失败！");
          }
        });
        this.delVisible = false;
      }
    },
    handleCloseVisible() {
      // this.teacher_id = "";
      this.delVisible = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
    // 获取数据
    getData() {
      this.searchSubmit();
      // this.$axios.get("/AccountProjectRole/").then(res => {
      //   if (res.data.hasError == false) {
      //     this.dataList = [...res.data.data];
      //     this.total = res.data.total;;
      //   }
      // });
    }
  },
  components: {
    EditUserRole,
    DeleteDialog
  }
};
</script>
<style lang="scss" scope>
.wrap {
  box-sizing: border-box;
  padding:0 10px;
  border-radius: 5px;
  position: relative;
  height:100%;
  background:#fff;
  .pag {
    position: absolute;
    bottom: 10px;
  }.table-wrap {
    height: calc(100% );
  }
}
.uers-left {
  float: left;
}
.uers-right {
  float: right;
}
</style>